import {Tag} from "antd";
import React from "react";
import ResultTable from "../../components/table/ResultTable";
import ResultHeader from "../../components/table/ResultHeader";
import ResultBody from "../../components/table/ResultBody";
import ResultRow from "../../components/table/ResultRow";
import ResultBodyCell from "../../components/table/ResultBodyCell";
import ResultHeaderCell from "../../components/table/ResultHeaderCell";
import {useAppContext} from "../../context/AppContext";


export default function MessageSelectedCheck({dataSource}) {
    const {resolveHistorySelection} = useAppContext()
    const resolveBase = (record) => (resolveHistorySelection(record) || {base: {}}).base || {}

    return (
        <>
            <ResultTable>
                <ResultHeader>
                    <ResultRow>
                        <ResultHeaderCell style={{textAlign: 'start'}}>Folder</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'start'}}>Project</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'start'}}>Plan</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'start'}}>River</ResultHeaderCell>
                    </ResultRow>
                </ResultHeader>
                <ResultBody>
                    {
                        dataSource.map(record => {
                            const base = resolveBase(record)
                            return (
                                <ResultRow>
                                    <ResultBodyCell style={{textAlign: 'start', minWidth: 125,}}>
                                        {base?.project?.information?.folderName}
                                    </ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'start', minWidth: 125,}}>
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                            }}
                                        >
                                            <Tag>{base?.project?.modelType}</Tag>
                                            <span>{base?.project?.information?.title?.trim()}</span>
                                        </div>
                                    </ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'start', minWidth: 125}}>
                                        {base?.plan?.type}
                                    </ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'start', minWidth: 125}}>
                                        <div>
                                            {(record?.selection?.base?.river?.river) && (
                                                <>
                                                    {record?.selection?.base?.river?.river} - {record?.selection?.base?.river?.reach}
                                                </>
                                            )}
                                            {!(record?.selection?.base?.river?.river) && (
                                                <>
                                                    -
                                                </>
                                            )}
                                        </div>
                                    </ResultBodyCell>
                                </ResultRow>
                            )
                        })
                    }
                </ResultBody>
            </ResultTable>
        </>
    )
}